(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ac-customer-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('customer-artwork-gallery')) {
    class CustomerArtworkGallery extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        const cards = Array.from(this.querySelectorAll('[data-gallery-card]'));
        const limit = Number(this.dataset.limit) || 6;
        this.track = this.querySelector('[data-gallery-track]');
        this.viewport = this.querySelector('[data-gallery-viewport]');
        this.controls = this.querySelector('[data-gallery-controls]');
        this.status = this.querySelector('[data-gallery-status]');
        this.previousButton = this.querySelector('[data-gallery-previous]');
        this.nextButton = this.querySelector('[data-gallery-next]');
        this.currentIndex = 0;

        for (let index = cards.length - 1; index > 0; index -= 1) {
          const randomIndex = Math.floor(Math.random() * (index + 1));
          [cards[index], cards[randomIndex]] = [cards[randomIndex], cards[index]];
        }

        cards.forEach((card, index) => {
          card.hidden = index >= limit;
          this.track.append(card);
        });

        this.cards = cards.slice(0, limit);
        this.previousButton.addEventListener('click', () => this.move(-1));
        this.nextButton.addEventListener('click', () => this.move(1));

        let touchStartX = 0;
        this.viewport.addEventListener('touchstart', (event) => {
          touchStartX = event.touches[0].clientX;
        }, { passive: true });
        this.viewport.addEventListener('touchend', (event) => {
          const distance = event.changedTouches[0].clientX - touchStartX;
          if (Math.abs(distance) > 45) this.move(distance > 0 ? -1 : 1);
        }, { passive: true });

        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.viewport);
        this.update();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      get visibleCount() {
        return window.matchMedia('(max-width: 749px)').matches ? 2 : 3;
      }

      move(direction) {
        const maximumIndex = Math.max(0, this.cards.length - this.visibleCount);
        this.currentIndex += direction;

        if (this.currentIndex > maximumIndex) this.currentIndex = 0;
        if (this.currentIndex < 0) this.currentIndex = maximumIndex;

        this.update();
      }

      update() {
        const maximumIndex = Math.max(0, this.cards.length - this.visibleCount);
        this.currentIndex = Math.min(this.currentIndex, maximumIndex);

        const currentCard = this.cards[this.currentIndex];
        const offset = currentCard ? currentCard.offsetLeft : 0;
        this.track.style.transform = `translate3d(${-offset}px, 0, 0)`;

        const lastVisible = Math.min(this.currentIndex + this.visibleCount, this.cards.length);
        this.status.textContent = `${this.currentIndex + 1}–${lastVisible} / ${this.cards.length}`;
        this.controls.hidden = this.cards.length <= this.visibleCount;
      }
    }

    customElements.define('customer-artwork-gallery', CustomerArtworkGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
